<template>
  <div class="docproduct">
    <Header />
    <Banner />
    <DocSolutionPage />
    <Footer />
  </div>
</template>

<script>
import Banner from '../components/Banner.vue'
import Footer from '../components/Footer.vue'
import Header from '@/components/Header.vue'
import DocSolutionPage from '@/components/DocSolutionPage.vue'

export default {
  name: 'docproduct',
  components: {
    DocSolutionPage,
    Header,
    Banner,
    Footer,
  }
}
</script>

<style lang="scss">

</style>